module.exports = __webpack_public_path__ + "img/Suzan_O_20.53f136e3.jpg";